import { ISubmitResponse } from '@interfaces/models/ISubmitResponse';
import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import { createAction, props } from '@ngrx/store';

export const validateOpenAccount = createAction('[Open Account] Validate open account');

export const validateOpenAccountResponse = createAction(
  '[Open Account] Open account response',
  props<{ payload: boolean }>(),
);

export const validateOpenAccountFailure = createAction(
  '[Open Account] Validate open account failure',
);

export const submitOpenAccount = createAction('[Open Account] Submit open account');

export const submitOpenAccountComplete = createAction(
  '[Open Account] Submit open account complete',
);

export const submitOpenAccountResponse = createAction(
  '[Open Account] Submit open account response',
  props<{ payload: ISubmitResponse }>(),
);
export const submitOpenAccountFailure = createAction('[Open Account] Submit open account failure');

export const updateSettlementFundChoice = createAction(
  '[Open Account] Update Settlement Fund Response',
  props<{ payload: SettlementFundAoAEnum }>(),
);
